// Checksum rules: https://abr.business.gov.au/Help/AbnFormat
const ABN_LENGTH = 11
const ABN_WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
const ABN_MODULUS = 89

export type AbnChecksumStatus = 'pending' | 'invalid' | 'valid'

export function normaliseAbn(value: string): string {
  return value.replace(/\s+/g, '')
}

// Checksum only, does not confirm the ABN exists on the register
export function isValidAbnChecksum(value: string): boolean {
  const abn = normaliseAbn(value)
  if (!/^\d{11}$/.test(abn)) {
    return false
  }

  const sum = ABN_WEIGHTS.reduce((acc, weight, index) => {
    // The first digit is reduced by 1 before weighting
    const digit = Number(abn[index]) - (index === 0 ? 1 : 0)
    return acc + weight * digit
  }, 0)

  return sum % ABN_MODULUS === 0
}

export function getAbnChecksumStatus(value: string): AbnChecksumStatus {
  const abn = normaliseAbn(value)
  if (abn.length < ABN_LENGTH) {
    return 'pending'
  }
  return isValidAbnChecksum(abn) ? 'valid' : 'invalid'
}
